module.exports = __webpack_public_path__ + "static/img/icon-call.234ea935.png";